<template>
   <div class="publicViewClass PrintingPaper" style="padding-top:0" id="publicWaterMark">
    <div class="app-inner paperFx">
          <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/teacheManage/enTestPaper')">
            返回
            </div>
            </div>
          <div class="exam-title">
              <div class="exam-title-info flex align-cen">
                <b>{{list.paperName}}</b>
                     <div class="mft right flex align-cen">
                   <div class="btn-set stastic-exam-actions" @click="isOpen" style="margin-left:20px">
                    {{isTrue ? "隐藏答案和解析" : "显示答案和解析"}}
                  </div>
                  <div class="btn-set exportExamSa" @click="printQ">
                    打印
                  </div>
                </div>
              </div>
            </div>
            <div class="exam-content">
                        <vue-easy-print ref="listPrint" tableShow>
                          <div class="eprintDiv ">
                          <div class="">
              <div class="text-center">
                <h1 class="flex justify-content-cen">{{list.paperName}}</h1>
                <div class="flex align-cen justify-content-cen">
                  <span>总分：{{list.paperScore}}</span>
                  <span style="padding:0 10px"> | </span>
                  <span v-if="list.answerTimeControl != 3">
                    限制{{list.answerTimeLimit}}分钟
                  </span>
                  <span v-if="list.answerTimeControl == 3">
                    限制每题{{list.singleDuration}}分钟
                  </span>
                </div>
              </div>
              <!-- 题目列表 -->
              <div class="questions">
                  <div class="questions-item" v-for="(item,index) in questions">
                    <div class="ques-title flex align-cen">
                      <div class="ques-number">{{index + 1}}/{{questions.length}}</div>
                       <span class="ques-type">{{item.type == 1 ? '单选题' : item.type == 2 ? '多选题' : item.type == 3 ? '判断题' : '填空题'}}</span>
                        <span v-html="item.title" style="max-width:70%"></span>
                         <AudioTem :audioSrc="item.audio" v-if="item.audio"></AudioTem>
                          <span class="ques-sorce" >（{{item.score}}分）</span>
                    </div>
                    <div class="question-option-list"> 
                        <ol  v-if="item.type !=4">
                        <li v-for="(sonitem,sonIndex) in item.answerList">
                            <p v-html="sonitem.content"></p>
                        </li>
                            </ol>
                   <div class="test_result" v-if="isTrue">
                        <div class="rightAnswer flex">
                             <span v-if="item.type !=4">
                                正确答案：
                                <span v-for="(sonitem,sonIndex) in item.answerList">
                                    <strong  v-if="sonitem.isRight == 1">
                                    {{Eng[sonIndex]}}
                                </strong>
                                </span>
                            </span>
                            <span v-if="item.type ==4">
                                 正确答案：
                                <span v-for="(sonitem,sonIndex) in item.answerList">
                                    <strong  v-if="sonitem.isRight == 1">
                                    {{sonitem.content}}<span v-if="sonIndex !=item.answerList.length - 1">，</span>
                                </strong>
                                </span>
                               </span>
                        </div>
                         <div class="jx">
                            题目解析：<span v-html="item.analysis || '暂无解析'"></span>
                         </div>
                    </div>
                    </div>
                  </div>
              </div>
              </div>
              </div>
               </vue-easy-print>
            </div>
           
    </div>
   </div>
</template>
<script>
import {getPaper,getAllTopic} from "@/api/enterprise/index"  //获取试卷详情、根据id查询题目列表
import mycomponents from "@/utils/compoments.js";
import WaterMark from '@/utils/waterMark.js'
import vueEasyPrint from "vue-easy-print";
export default {
    name:'PrintingPaper',
      components: {
        vueEasyPrint,
         AudioTem: mycomponents.components.PublicAudio
    },
    data() {
        return {
          maLft:false,
          checked:true,
           Eng:['A','B','C','D','E','F','G','H','I','J'],
            list:{},
            questions:[],
            isTrue:false,
            businessInfo:{}
        }
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getPaperDetail()
        this.getTopicPage()
    },
    methods: {
      // 打印
      printQ(){
       this.$nextTick(() => {
        this.$refs.listPrint.print();
      })
      },
                  // 设置水印
    showMark() {
      this.waterMark = new WaterMark({
        watermark_txt: '和隆优化', // 水印的内容
        watermark_x: 0, // 水印起始位置x轴坐标
        watermark_y: 0, // 水印起始位置Y轴坐标
        watermark_rows: 0, // 水印行数
        watermark_cols: 0, // 水印列数
        watermark_x_space: 50, // 水印x轴间隔
        watermark_y_space: 250, // 水印y轴间隔
        watermark_width: 350, // 水印宽度
        watermark_height: 50, // 水印长度
        watermark_angle: 35, // 水印倾斜度数
        monitor: false,
      });
    },
      isOpen(){
        this.isTrue = !this.isTrue
      },
       // 根据试卷ID查询题目列表
        getTopicPage(){
            getAllTopic({id:this.$route.query.id})
           .then(res =>{
            if(res.code == 0){
              this.questions = res.data || []
            }
            }) 
        },
         // 获取试卷详情
        getPaperDetail(){
            getPaper({id:this.$route.query.id},'get')
            .then(res =>{
              this.list = res.data
                if(this.list.watermark == 1){
                             this.showMark()
               }
            })
            .catch(err =>{})
        },
    },
}
</script>
<style lang="scss" scoped>
@page {

  size: auto A4 landscape;

  margin: 3mm;

}
.eprintDiv{
  width:60%;
    margin: 0 auto;
}
.PrintingPaper{
  height: inherit;
  overflow: hidden;
}
.paperFx{
    height: calc(100% - 120px);
  .exam-title{
    position: relative;
    padding: 0 24px;
    background-color: #ffffff;
    border-bottom: solid 1px #e6e6e6;
    border-radius: 10px 10px 0 0;
    cursor: default;
    padding-bottom: 15px;
    b{
      font-weight: bolder;
          font-size: 20px;
    color: #333333;
    font-weight: 600;
    }
    .title-extra{
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }
        .right{
      .btn-set{
        min-width: 120px;
        margin-right: 16px;
        cursor: pointer;
        color: #409eff;
        border: 1px solid #409eff;
        padding: 7px 10px;
        border-radius: 4px!important;
        text-align: center;
      }
      .exportExamSa{
        border: none;
        background: #409eff;
        color: #fff;
      }
    }
  }
  .exam-content{
    height:calc(100% - 90px);
    margin-top: 30px;
    overflow-y: auto;
    .text-center{
      margin-bottom: 50px;
      text-align: center;
    }
  }
  .questions{
    .questions-item{
      margin-bottom: 14px;
      .ques-title{
        font-size: 17px;
          vertical-align: middle;
          line-height: 35px;
          -webkit-margin-before: 0;
          -webkit-margin-after: 0;
          word-break: break-word;
          .ques-number {
            font-size: 17px;
            padding: 0;
            background-color: transparent;
            color: #222;
        }
        .ques-type{
          margin: 0 12px;
        }
        .ques-sorce{
          color: #aeaeae;
        }
      }
          .question-option-list{
                padding: 0 20px;
                margin-top: 30px;
                li{
                    list-style-type: upper-latin;
                    margin-bottom: 15px;
                    font-size: 17px;
                }
                li::marker{
                    unicode-bidi: isolate;
                font-variant-numeric: tabular-nums;
                text-transform: none;
                text-indent: 0px !important;
                text-align: start !important;
                text-align-last: start !important; 
                }
                .test_result{
                    margin-left: -20px;
                    .rightAnswer{
                        color: #36aafd;
                    }
                    .jx{
                        color: #999;
                        padding-top: 10px;
                    }
                }
            }
    }
  }
}
</style>